<div class="footer-copyright">
  <div class="container container-lg">
    <div class="footer-copyright__line">
      <p class="footer-copyright__text">
        <span class="footer-copyright__profile">Copyright © 2021 {{(profile$ | async)?.denominazione}}{{((profile$ | async)?.piva) ? (' - P.I. ' + (profile$ | async)?.piva) : ''}}</span>
        <span class="footer-copyright__oto">Proudly powered by <a target="_blank" href="https://www.otosrl.com/">OTO</a></span>
      </p>
    </div>
  </div>
</div>